import styled, { css } from 'styled-components';
import { THEME } from './theme';

export const PagePad = styled.div`
	padding: 34px min(5vw, 64px) 48px;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		padding: 16px ${THEME.mobileGutter} calc(28px + env(safe-area-inset-bottom, 0px));
	}
`;

export const HomePagePad = styled(PagePad)`
	padding-top: 18px;
	min-width: 0;
	width: 100%;
	max-width: 100%;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		padding-top: 16px;
		padding-bottom: calc(24px + env(safe-area-inset-bottom, 0px));
	}
`;

export const PersonGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
	gap: 20px;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
	}
`;

export const SectionHeading = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: baseline;
	gap: 16px;
	margin-bottom: 18px;

	h2 {
		margin-bottom: 0;
		font-size: clamp(1.45rem, 2.8vw, 2rem);
	}
`;

export const EmptyState = styled.div`
	border: 1px dashed rgba(255, 255, 255, 0.18);
	border-radius: 8px;
	padding: 28px;
	color: ${THEME.muted};
	background: rgba(176, 38, 255, 0.06);
`;

export const PrimaryAction = styled.button`
	min-height: 42px;
	border-radius: 8px;
	border: 1px solid transparent;
	padding: 0 16px;
	color: ${THEME.text};
	font-weight: 800;
	background: ${THEME.gradientPrimary};
	box-shadow: 0 0 24px rgba(255, 77, 242, 0.32);
`;

export const GhostAction = styled.button`
	min-height: 42px;
	border-radius: 8px;
	border: 1px solid ${THEME.line};
	padding: 0 16px;
	color: ${THEME.text};
	font-weight: 800;
	background: rgba(255, 255, 255, 0.055);
`;

export const Chip = styled.button`
	flex: 0 0 auto;
	min-height: 32px;
	border-radius: 999px;
	border: 1px solid rgba(255, 180, 236, 0.18);
	padding: 0 15px;
	background:
		linear-gradient(135deg, rgba(255, 255, 255, 0.07), rgba(255, 255, 255, 0.025)),
		rgba(26, 15, 30, 0.84);
	color: rgba(255, 231, 250, 0.88);
	font-family: ${THEME.fontApp};
	font-size: 0.74rem;
	font-weight: 800;
	white-space: nowrap;
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.055);
	transition:
		border-color 0.18s ease,
		background 0.18s ease,
		box-shadow 0.18s ease,
		color 0.18s ease;

	&:hover,
	&:focus-visible {
		border-color: rgba(255, 119, 244, 0.34);
		color: #ffffff;
		background:
			linear-gradient(135deg, rgba(255, 77, 242, 0.14), rgba(255, 180, 107, 0.13)),
			rgba(38, 20, 42, 0.88);
		box-shadow: 0 0 16px rgba(255, 77, 242, 0.12);
	}

	${(props) =>
		props.$active &&
		css`
			border-color: rgba(255, 162, 241, 0.42);
			color: #ffffff;
			background:
				linear-gradient(
					135deg,
					rgba(203, 43, 255, 0.92),
					rgba(255, 58, 208, 0.7) 56%,
					rgba(255, 184, 119, 0.58)
				),
				rgba(42, 19, 48, 0.9);
			text-shadow: 0 0 10px rgba(255, 255, 255, 0.28);
			box-shadow:
				inset 0 1px 0 rgba(255, 255, 255, 0.16),
				0 0 18px rgba(255, 77, 242, 0.24);
		`}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		min-height: 36px;
		padding: 0 16px;
		font-size: 0.8125rem;
	}
`;
